"use strict";
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
var styles = {
    imageContainer: 'imageContainer_b76b6e49',
};
load_themed_styles_1.loadStyles([{ "rawString": ".imageContainer_b76b6e49{overflow:hidden}" }]);
module.exports = styles;
/* tslint:enable */ 

//# sourceMappingURL=Icon.scss.js.map



//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Icon/Icon.scss.js
// module id = 248
// module chunks = 0